import useUserPermissionList from 'api/users/useUserPermissionList/useUserPermissionList';
import UserPermissionsModal from 'components/private/Modals/users/UserPermissionsModal/UserPermissionsModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import useUserPermissionListTableColumns from 'hooks/users/useUserPermissionListTableColumns';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

const UserPermissionList = () => {
  const { userGuid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [selectedRows, setSelectedRows] = useState([]);

  const [activeModal, setActiveModal] = useState(null);

  const { getUserPermissionList, loading, pageRef, permissionList } =
    useUserPermissionList();
  const tableRef = useRef(null);
  const { can } = usePermissions();

  const canEditPermissions = can(
    permissions.general.categories.globalSettings.usersManagement.users
      .permissionsEdit,
  );

  const fetchPermissions = useCallback(() => {
    getUserPermissionList(
      { Guid: userGuid, Page: page, Count: pageSize },
      () => {
        setPage(page);
      },
    );
  }, [getUserPermissionList, userGuid, pageSize]);

  useEffect(() => {
    if (!userGuid) return;
    fetchPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userGuid]);

  const closeModal = useCallback(() => setActiveModal(null), []);

  const [columnsData] = useUserPermissionListTableColumns({
    apiRef: tableRef,
  });

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getUserPermissionList({
      Guid: userGuid,
      Page: pageNumber,
      Count: pageSize,
    });
  }

  return (
    <>
      <div>{pageRef?.refTitle}</div>
      {Object.keys(permissionList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={permissionList[page]}
          rows={permissionList[page]}
          pageSize={pageSize}
          isDeletable={false}
          isLoading={loading}
          addLable={canEditPermissions ? 'تغییر دسترسی' : undefined}
          onAddClick={
            canEditPermissions
              ? () => setActiveModal('editPermission')
              : undefined
          }
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          disableSelection
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          setSelectedRows={rows => setSelectedRows(rows)}
          selectedRows={selectedRows}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canEditPermissions ? (
        <UserPermissionsModal
          onAssignPermissionSuccess={fetchPermissions}
          open={activeModal === 'editPermission'}
          handleClose={closeModal}
          editLoading={loading}
          userGuid={userGuid}
        />
      ) : null}
    </>
  );
};

export default UserPermissionList;
